import React from 'react';
import PropTypes from 'prop-types';
import { PayloadStates } from '@lore/utils';
import DialogTemplate from '@/dialogs_common/DialogTemplate';
import Loader from '@/components/Loader';
import Event from './DialogLayout';
import CloseDialogButton from '@/dialogs_common/CloseDialogButton';

EventManageDialog.propTypes = {
  event: PropTypes.object.isRequired,
  onCancel: PropTypes.func,
};

export default function EventManageDialog(props) {
  const { event } = props;

  if (event.state === PayloadStates.FETCHING) {
    return (
      <DialogTemplate>
        <Loader />
      </DialogTemplate>
    );
  }

  return (
    <DialogTemplate className="w-screen max-w-screen-lg relative">
      <p className="text-base text-cs-gray-900 absolute top-6 left-8">Your event</p>
      <CloseDialogButton onCancel={props.onCancel}/>
      <div className="px-6 pt-16 pb-6">
        <Event
          event={event}
          onClose={props.onCancel}
        />
      </div>
    </DialogTemplate>
  );
};
